var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNewMappingDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 2H9L7.2 0H1.8C0.801 0 0.00899999 0.77875 0.00899999 1.75L0 13.25C0 14.2212 0.801 15 1.8 15H16.2C17.199 15 18 14.2212 18 13.25V3.75C18 2.77875 17.199 2 16.2 2ZM16 9.375H13.3V12H11.5V9.375H8.8V7.625H11.5V5H13.3V7.625H16V9.375Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewMappingDisabled);
export default __webpack_public_path__ + "static/media/icon-new-mapping-disabled.cc4cfc83f0913323275b6032b625fde1.svg";
export { ForwardRef as ReactComponent };